var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_12918)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55215 37.3763L13.152 26.7765L11.7967 25.4212C11.0397 24.6642 10.033 24.2471 8.96219 24.2471C7.89148 24.2471 6.88474 24.6642 6.12778 25.4212L1.19687 30.352C0.439911 31.109 0.0227966 32.1158 0.0227966 33.1865C0.0227966 34.2575 0.439911 35.264 1.19687 36.021L2.55215 37.3763Z",
    fill: "#006838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.379 2.55042L36.0237 1.19513C35.2667 0.43808 34.2599 0.0209961 33.1892 0.0209961C32.1185 0.0209961 31.1117 0.43808 30.3547 1.19513L25.4236 6.12595C23.8608 7.68866 23.8608 10.2318 25.4236 11.7949L26.7789 13.1502L37.379 2.55042Z",
    fill: "#006838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41687 39.1548C7.99336 42.1186 12.5922 42.7656 17.8026 41.013C22.266 39.5114 27.2036 36.2054 31.7055 31.7036C36.2073 27.2017 39.5137 22.2642 41.0149 17.8004C42.7675 12.5904 42.1205 7.99155 39.1567 4.41504L28.5057 15.0661C30.7944 18.6339 27.5034 22.8573 25.1814 25.1793C22.8591 27.5013 18.6357 30.7926 15.0682 28.5036L4.41687 39.1548Z",
    fill: "#006838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_12918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.9562,
    height: 41.9561,
    fill: "white",
    transform: "matrix(-1 0 0 1 41.979 0.0209961)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.32df56acb2716f3a3b7cb5887c1e530a.svg";
export { ForwardRef as ReactComponent };